export const USERS_OPEN_ADD_MODAL = "app/Users/OPEN_ADD_MODAL";
export const USERS_CLOSE_ADD_MODAL = "app/Users/CLOSE_ADD_MODAL";
export const USERS_EDIT_MODAL_OPEN_AND_FETCH =
  "app/Users/EDIT_MODAL_OPEN_AND_FETCH";
export const USERS_CLOSE_EDIT_MODAL = "app/Users/CLOSE_EDIT_MODAL";
export const USERS_VIEW_MODAL_OPEN_AND_FETCH =
  "app/Users/VIEW_MODAL_OPEN_AND_FETCH";
export const USERS_MODAL_SET_USER = "app/Users/MODAL_SET_USER";
export const USERS_CLOSE_VIEW_MODAL = "app/Users/CLOSE_VIEW_MODAL";
export const GET_USER_PENDING = "app/Users/GET_USER_PENDING";
export const GET_USER_SUCCESS = "app/Users/GET_USER_SUCCESS";
export const GET_USER_FAILURE = "app/Users/GET_USER_FAILURE";
export const LOAD_USERS = "app/Users/LOAD_USERS";

export const USER_SAVE_PENDING = "app/Users/USER_SAVE_PENDING";
export const USER_SAVE_SUCCESS = "app/Users/USER_SAVE_SUCCESS";
export const USER_SAVE_FAILURE = "app/Users/USER_SAVE_FAILURE";
export const USER_SAVE = "app/Users/USER_SAVE";

export const USER_EDIT_PENDING = "app/Users/USER_EDIT_PENDING";
export const USER_EDIT_SUCCESS = "app/Users/USER_EDIT_SUCCESS";
export const USER_EDIT_FAILURE = "app/Users/USER_EDIT_FAILURE";
export const USER_EDIT = "app/Users/USER_EDIT";

export const DELETE_USER_PENDING = "app/Users/DELETE_USER_PENDING";
export const DELETE_USER_SUCCESS = "app/Users/DELETE_USER_SUCCESS";
export const DELETE_USER_FAILURE = "app/Users/DELETE_USER_FAILURE";
export const DELETE_USER = "app/Users/DELETE_USER";

export const UPDATE_USER_PROFILE = "app/Users/UPDATE_USER_PROFILE";
export const UPDATE_USER_PROFILE_PENDING =
  "app/Users/UPDATE_USER_PROFILE_PENDING";
export const UPDATE_USER_PROFILE_SUCCESS =
  "app/Users/UPDATE_USER_PROFILE_SUCCESS";
export const UPDATE_USER_PROFILE_FAILURE =
  "app/Users/UPDATE_USER_PROFILE_FAILURE";

export const CHANGE_PASSWORD = "app/Users/CHANGE_PASSWORD";
export const CHANGE_PASSWORD_SUCCESS = "app/Users/CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAILURE = "app/Users/CHANGE_PASSWORD_FAILURE";
